import { useEffect, useRef, useState } from 'react';
import { HTTP_METHOD, getDefaultOptions } from '../async/GetAsyncOptions';
import { IAppConfig } from '../interface/IAppConfig';

export const useStakeholder = <T = unknown>(props: IAppConfig) => {
  const isLoggedOn = window.topContext.user.isLoggedOn;
  const isLoading = useRef(false);
  const [stakeholder, setStakeholder] = useState<T | undefined>(undefined);
  const [isBornholm, setIsBornholm] = useState<boolean | undefined>(undefined);
  const [error, setError] = useState<unknown>(false);

  const zipcodeIsBornholm = (zipCode: number | string): boolean => {
    if (typeof zipCode === 'number') {
      return zipCode >= 3700 && zipCode <= 3799;
    } else {
      return /^37\d{2}.*$/.test(zipCode);
    }
  };

  useEffect(() => {
    const fetchStakeholder = async () => {
      const options = getDefaultOptions(HTTP_METHOD.GET, props, 'wso2Secured');
      try {
        const response = await fetch(`${props.apiGatewayBase}/v2/gti-services/api/stakeholder`, options);
        if (response.ok) {
          const data = await response.json();
          setStakeholder(data);

          setIsBornholm(zipcodeIsBornholm(data?.zipCity ?? ''));
        } else {
          setError(true);
        }
      } catch (error) {
        setError(error);
      } finally {
        isLoading.current = false;
      }
    };

    if (!isLoading.current && isLoggedOn) {
      isLoading.current = true;
      fetchStakeholder();
    }
  }, [props, isLoggedOn]);

  return { stakeholder, isLoading: isLoading.current, error, isBornholm };
};
